import styled from 'styled-components';
import { useOverlay } from '../context/overlayContext';

const Overlay = () => {
  const { nodes } = useOverlay();

  return nodes ? <OverlayBackground>{nodes}</OverlayBackground> : null;
};

export default Overlay;

export const OverlayBackground = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.65);
  backdrop-filter: saturate(100%) blur(4px);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;
